
import React, { Component } from 'react';
import './add-new-class.scss'
import { Modal, ModalBody } from "reactstrap";

import SchoolApi from '../../../apis/school'
import Dropdown from '../../common/dropdown-v2/dropdown';
// import CommonApi from '../../../apis/common'
import { ImageConstants, } from '../../../constants/constants';
import { getImageSource } from '../../../utility/image-source'
import AddNewTeacher from '../../teachers/add-new-contact/add-new-contact';

class AddAdminComponent extends Component {
    constructor(props) {
        super(props)

    }

    state = {
        classes: [],
        types: [],
        selectedClass: null,
        countryCodeDropdown: [],
        classesDropdown: []
    }


    componentDidMount() {
        this.getClasses()
    }


    getClasses(payload = {}) {
        payload.display = "SHOW"
        payload.sortType = 'asc'
        payload.sortKey = 'order'
        SchoolApi.getClasses(payload)
            .then(response => {
                let items = [];
                for (let i = 0; i < response?.response?.length; i++) {
                    if (this.props.classes.includes(response?.response[i].title)) continue
                    items.push({
                        title: response?.response[i].title,
                        value: response?.response[i].title,
                    })
                }

                this.setState({ classesDropdown: items, reloadDropdown: true }, () => {
                    this.setState({ reloadDropdown: false })
                })
            }).catch(err => {
            })

    }

    onSave() {

        let payload = {
            class: this.state.selectedClass
        }

        if (!this.validatePayload(payload)) return
        this.setState({ isSubmit: true })
        SchoolApi.updateSchoolClass(payload)
            .then(staffs => {
                this.props.onSave && this.props.onSave(true)
            }).catch(err => {
            })

    }

    validatePayload(payload) {
        if (!this.state.selectedClass) {
            this.setState({ errorMessage: "Please select the class" })
            return false
        }
        this.setState({ errorMessage: "" })
        return true
    }

    addNewContact = () => {
        this.setState({ showAddNewTeacher: true })
    }

    onSelectClass = (option) => {
        this.setState({ selectedClass: option?.value })
    }


    render() {
        return (
            <div className="add-new-class">

                <div className='row pt-5'>
                    <div className='col-2'></div>
                    <div className='col-8'>
                        {
                            !this.state.reloadDropdown ?
                                <Dropdown
                                    key="users"
                                    placeholder='Select from the list'
                                    options={this.state.classesDropdown}
                                    onSelect={(option) => this.onSelectClass(option)}
                                    text="title"
                                    style={{ background: "#F6F7F5" }}
                                    value={this.state.selectedClass}
                                    invalid={this.state.isSubmit && !this.state.selectedClass}
                                />
                                :
                                ""
                        }
                    </div>
                </div>



                <div className="text-center pt-5">
                    {
                        this.state.selectedClass ?
                            <button className="cw-button-primary" onClick={() => this.onSave()}>
                                ADD
                            </button>
                            :
                            <button className="cw-button-disabled" >
                                ADD
                            </button>
                    }
                </div>
            </div>
        );
    }
}

export default AddAdminComponent;